export default {"id":"a7e6feb7","attrs":{"viewBox":"0 0 28 28","width":"24","height":"24"}}